<template>
  <v-container class="pb-0">
    <v-row>
      <v-col md="3" sm="12">
        <v-text-field
          v-model="filters.name"
          :label="$t('common.name')"
          solo
          dense
        ></v-text-field>
      </v-col>
      <v-col md="3" sm="12">
        <v-text-field
          v-model="filters.email"
          :label="$t('common.email')"
          solo
          dense
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12">
        <v-select
          v-model="filters.role"
          :items="roles"
          :label="$t('common.selectRole')"
          solo
          dense
        ></v-select>
      </v-col>
      <v-col md="2" xs="6">
        <v-btn color="default" block @click="reset()">
          {{ $t('common.reset') }}
        </v-btn>
      </v-col>
      <v-col md="2" xs="12">
        <v-btn color="primary" block @click="filter()">
          {{ $t('common.filter') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import userRoles from '../../../enums/user.roles';
import listFilterMixin from '../../shared/mixins/list.filter.mixin';

export default {
  name: 'users-list-filter',
  mixins: [listFilterMixin],
  data() {
    return {
      defaultFilters: {
        name: null,
        email: null,
        role: null
      },
      roles: [
        {
          text: this.$i18n.t('common.selectRole'),
          value: ''
        },
        {
          text: this.$i18n.t('roles.admin'),
          value: userRoles.admin
        },
        {
          text: this.$i18n.t('roles.user'),
          value: userRoles.user
        }
      ]
    };
  }
};
</script>
